import AdvancedReportView from "@/views/advanced-report/AdvancedReportView.vue";
import HomeView from "@/views/home/HomeView.vue";
import ObjectivesReportView from "@/views/objectives-report/ObjectivesReportView.vue";
import ResultsReportView from "@/views/results-report/ResultsReportView.vue";
const routes = [
    // {
    //   path: "/",
    //   name: "dashboard",
    //   component: Home,
    //   type: "brand",
    //   meta: {
    //     title: "Dashboard",
    //   },
    // },
    // {
    //   path: "/",
    //   name: "dashboard",
    //   component: Home,
    //   type: "header-nav",
    //   label: "Home",
    //   meta: {
    //     title: "Dashboard",
    //   },
    // },
    // {
    //   path: "/objectives-v2",
    //   name: "objectives-v2",
    //   component: ObjectivesV2,
    //   type: "header-nav",
    //   label: "Objetivos",
    //   meta: {
    //     title: "Objetivos",
    //   },
    // },
    // {
    //   path: "/results",
    //   name: "results",
    //   component: Results,
    //   type: "header-nav",
    //   label: "Informe de resultados",
    //   meta: {
    //     title: "Informe de resultados",
    //   },
    // },
    {
        path: "/",
        name: "dashboard",
        component: HomeView,
        type: "brand",
        meta: {
            title: "Dashboard",
        },
    },
    {
        path: "/",
        name: "home",
        component: HomeView,
        type: "header-nav",
        label: "Home",
        meta: {
            title: "Dashboard",
        },
    },
    {
        path: "/objectives-report",
        name: "objectives-report",
        component: ObjectivesReportView,
        type: "header-nav",
        label: "Objetivos",
        meta: {
            title: "Objetivos",
        },
    },
    {
        path: "/results-report",
        name: "results-report",
        component: ResultsReportView,
        type: "header-nav",
        label: "Informe de resultados",
        meta: {
            title: "Informe de resultados",
        },
    },
    {
        path: "/advanced-report",
        name: "advanced-report",
        component: AdvancedReportView,
        type: "header-nav",
        label: "Informe avanzado",
        meta: {
            title: "Informe avanzado",
        },
    },
];
export default routes;
